import { TURN_TRACKER_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const allTurnTracker: RouteRecordRaw[] = [
  {
    path: '',
    name: TURN_TRACKER_ROUTE_NAME.TURN_TRACKER,
    component: () => import('@/pages/turn-tracker/index.vue'),
    meta: {
      requireAuth: true,
    },
  },
];
